import { formatToThaiDate } from '@Utils/datetime';
import { STATUS_MESSAGES } from 'src/Constant/Status';

const dateNow = new Date().toISOString().split('T')[0];

export const checkScoreUndefined = (
  score: number | null | undefined
): number | null => (score === undefined ? null : score);

export const getSeverity = (
  isSuccess: boolean,
  isScoreValid: boolean,
  isCgrPass: boolean
) => {
  if (!isSuccess || !isScoreValid) return 'error';
  return isCgrPass ? 'success' : 'warning';
};

export const getStatusMessage = (
  isSuccess: boolean,
  isScoreValid: boolean,
  isCgrPass: boolean
) => {
  if (!isSuccess) return STATUS_MESSAGES.GET_API_CGR_FAIL;
  if (!isScoreValid) return STATUS_MESSAGES.CGR_SCORE_NULL;
  return isCgrPass ? STATUS_MESSAGES.CGR_PASS : STATUS_MESSAGES.CGR_NOT_PASS;
};

export const getScoreText = (
  isSuccess: boolean,
  isScoreValid: boolean,
  score: number | null | undefined
) => {
  if (!isSuccess) return 'ไม่สามารถดึงข้อมูลคะแนน';
  return isScoreValid ? `${score} คะแนน` : 'ไม่มีคะแนน';
};

export const formatUpdateDate = (updateDate: string | undefined) => {
  return formatToThaiDate(updateDate || dateNow);
};
